/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { usePlayerConfig } from "../../../shared/context/PlayerConfigContext";
import { usePlayerSettings } from "../../BasePlayer";

export const useContinueWatchingConfiguration = () => {
  const { progressSyncInterval } = usePlayerConfig();

  const {
    continueWatching: { syncIntervalMs },
  } = usePlayerSettings();

  const baseSyncInterval = progressSyncInterval || syncIntervalMs;

  const syncIntervalSeconds = baseSyncInterval / 1000;

  return {
    syncIntervalSeconds,
  };
};
